<template>
  <div>
    <div>
      <router-link
        v-if="createRoute != ''"
        v-role="createRole"
        v-permission="createPermission"
        :to="
          typeof createRoute == 'string' ? { name: createRoute } : createRoute
        "
        class="btn btn-success mb-2"
      >
        <i class="mdi mdi-plus"></i>
      </router-link>
    </div>
    <div
      class="row flex-nowrap align-items-center justify-content-between mt-4"
    >
      <div>
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center">
            نمایش&nbsp;
            <b-form-select
              v-model="perPage"
              size="sm"
              @change="fetchData"
              :options="pageOptions"
            ></b-form-select
            >&nbsp;رکورد
          </label>
        </div>
      </div>
      <div
        class="d-flex align-items-center justify-content-end col-12 col-md-8 ml-4"
      >
        <span
          style="width:100%"
          class="mr-4"
          v-if="$store.state.auth.user.is_admin == true"
        >
          <multiselect
            v-if="!hideDeveloperColumn"
            style="width:100%"
            :options="developers"
            track-by="id"
            label="full_name"
            v-model="selectedDevelopers"
            placeholder="توسعه دهنده"
            multiple
            @input="fetchData"
          ></multiselect>
        </span>
        <b-button
          @click="fetchData(false)"
          class="ml-2"
          variant="success"
          size="sm"
        >
          <i class="ri ri-refresh-line"></i>
        </b-button>
        <b-button
          v-if="!hideExcel"
          class="ml-2"
          @click="fetchData(true)"
          variant="info"
          size="sm"
        >
          <i class="ri ri-file-excel-line"></i>
        </b-button>
        <b-button variant="danger" class="ml-2" id="columns" size="sm">
          <i class="ri ri-layout-column-line"></i>
        </b-button>
        <b-popover target="columns" triggers="hover focus">
          <div class="d-flex flex-column">
            <template v-for="field in fields">
              <b-form-checkbox
                :key="field.key"
                v-if="field.key != 'rowIndex'"
                v-model="field.show"
                @input="fetchData(false)"
                >{{ field.label }}</b-form-checkbox
              >
            </template>
          </div>
        </b-popover>
      </div>
    </div>
    <!-- Table -->
    <div class="table-responsive mb-0">
      <b-table
        ref="table"
        class="crud-table"
        fixed
        :items="finalData"
        :fields="fields.filter((x) => x.show == true)"
        :per-page="0"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
        <template slot="top-row" slot-scope="{ fields }" class="text-center">
          <template v-for="(field, index) in fields" class="text-center">
            <td v-if="field.filter" :key="field.key">
              <span class="form-group text-center">
                <TableFilterColumn
                  v-model="field.filter.value"
                  @operator-change="operatorChange(index, $event)"
                  @input="fetchData(false)"
                  :field="field"
                />
              </span>
            </td>
            <td v-else :key="field.key"></td>
          </template>
        </template>

        <template
          v-for="cell in fields"
          v-slot:[getCellSlotName(cell.key)]="data"
        >
          <span :key="cell.key">
            <slot :name="`cell(${cell.key})`" :item="data.item">
              <span
                v-if="cell.formatPrice && $slots[`cell(${cell.key})`] == null"
                >{{ $helper.formatPrice(data.item[cell.key]) }}</span
              >
              <span v-else> {{ data.item[cell.key] }}</span>
            </slot>
          </span>
        </template>

        <template #cell(rowIndex)="data">
          <span class="d-flex align-items-center justify-content-center">
            <span>{{ perPage * (currentPage - 1) + data.index + 1 }}</span>
          </span>
        </template>

        <template #cell(user)="data">
          <span class="d-flex align-items-center justify-content-center">
            {{ data.item.user ? data.item.user.full_name : "" }}
          </span>
        </template>

        <template #cell(actions)="data">
          <slot
            name="cell(actions)"
            :item="data.item"
            :itemDeleted="itemDeleted"
          ></slot>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-right">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableFilterColumn from "./TableFilter/TableFilterColumn.vue";
export default {
  components: {
    TableFilterColumn,
  },
  props: {
    columns: {
      type: Array,
      required: true,
    },
    vuexPrefix: {
      type: String,
      required: true,
    },
    createRoute: {
      type: [String, Object],
      default: "",
    },
    createPermission: {
      type: String,
      default: "",
    },
    createRole: {
      type: String,
      default: "",
    },
    fetchAddress: {
      type: String,
      required: true,
    },
    hideExcel: {
      type: Boolean,
      default: false,
    },
    hideDeveloperColumn: {
      type: Boolean,
      default: false,
    },
    hideCreatedAtColumn: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sortBy: {
      get() {
        return this.$store.state.tables[this.vuexPrefix].sortBy;
      },
      set(value) {
        this.$store.commit("tables/UPDATE_PARAM", {
          tableName: this.vuexPrefix,
          key: "sortBy",
          value: value,
        });
      },
    },
    sortDesc: {
      get() {
        return this.$store.state.tables[this.vuexPrefix].sortDesc;
      },
      set(value) {
        this.$store.commit("tables/UPDATE_PARAM", {
          tableName: this.vuexPrefix,
          key: "sortDesc",
          value: value,
        });
      },
    },
    currentPage: {
      get() {
        return this.$store.state.tables[this.vuexPrefix].currentPage;
      },
      set(value) {
        this.$store.commit("tables/UPDATE_PARAM", {
          tableName: this.vuexPrefix,
          key: "currentPage",
          value: value,
        });
      },
    },
    isFetched: {
      get() {
        return this.$store.state.tables[this.vuexPrefix].isFetched;
      },
      set(value) {
        this.$store.commit("tables/UPDATE_PARAM", {
          tableName: this.vuexPrefix,
          key: "isFetched",
          value: value,
        });
      },
    },
    perPage: {
      get() {
        return this.$store.state.tables[this.vuexPrefix].perPage;
      },
      set(value) {
        this.$store.commit("tables/UPDATE_PARAM", {
          tableName: this.vuexPrefix,
          key: "perPage",
          value: value,
        });
      },
    },
    totalRows: {
      get() {
        return this.$store.state.tables[this.vuexPrefix].totalRows;
      },
      set(value) {
        this.$store.commit("tables/UPDATE_PARAM", {
          tableName: this.vuexPrefix,
          key: "totalRows",
          value: value,
        });
      },
    },
    finalData: {
      get() {
        return JSON.parse(
          JSON.stringify(this.$store.state.tables[this.vuexPrefix].data)
        );
      },
      set(value) {
        this.$store.commit("tables/UPDATE_PARAM", {
          tableName: this.vuexPrefix,
          key: "data",
          value: value,
        });
      },
    },
  },
  watch: {
    sortBy() {
      this.fetchData();
    },
    sortDesc() {
      this.fetchData();
    },
    currentPage() {
      this.fetchData();
    },
    fetchAddress() {
      this.fetchData();
    },
    columns() {
      this.setFields();
    },
  },
  data() {
    return {
      pageOptions: [10, 25, 50, 100],
      searchTimer: null,
      fields: [],
      developers: [],
      isAdmin: this.$store.state.auth.user.is_admin == true,
      selectedDevelopers: [],
    };
  },
  mounted() {
    this.setFields();
    if (this.isAdmin) {
      this.fetchDevelopers();
    } else {
      if (!this.isFetched) {
        this.fetchData();
      }
    }
  },
  methods: {
    setFields() {
      let columns = JSON.parse(JSON.stringify(this.columns));
      columns.forEach((item) => {
        if (item.show == undefined) {
          item.show = true;
        }
        item.class = "text-center";
      });
      if (
        this.$store.state.auth.user.is_admin == true &&
        !this.hideDeveloperColumn
      ) {
        columns.unshift({
          key: "user",
          sortable: true,
          label: "نام توسعه دهنده",
          thStyle: { width: "180px" },
          show: true,
          filter: {
            name: "user.name",
            component: "SearchFilter",
            operator: "$lk",
            value: "",
          },
        });
      }
      this.fields = [
        {
          key: "rowIndex",
          sortable: false,
          label: "ردیف",
          show: true,
          thStyle: { width: "60px" },
        },
        ...columns,
      ];

      if (!this.hideCreatedAtColumn) {
        this.fields.push({
          key: "created_at",
          sortable: true,
          label: "تاریخ ثبت",
          thStyle: { width: "200px" },
          tdStyle: { width: "200px" },
          thClass: "d-none d-md-table-cell",
          tdClass: "d-none d-md-table-cell",
          filter: {
            component: "DateFilter",
            operator: "$between",
            value: ["", ""],
          },
          show: true,
        });
      }

      this.fields.push({
        key: "actions",
        sortable: false,
        label: "عملیات",
        thStyle: { width: "250px" },
        thClass: "d-none d-md-table-cell",
        tdClass: "d-none d-md-table-cell",
        show: true,
      });
    },
    fetchData(excel = false) {
      const params = {
        page: this.currentPage,
        size: this.perPage,
        order_key: this.sortBy != "" ? this.sortBy : "created_at",
        order_by: this.sortDesc ? "desc" : "asc",
        columns: JSON.parse(
          JSON.stringify(
            this.fields
              .filter(
                (x) =>
                  x.show == true && x.key != "rowIndex" && x.key != "actions"
              )
              .map((item) => item.key)
          )
        ),
      };

      if (excel == true) {
        params.export = true;
      }

      const filters = {};
      this.fields.forEach((item) => {
        if (item.filter != null && item.show) {
          const filter = item.filter;
          if (Array.isArray(filter.value)) {
            if (filter.value[0] != "" || filter.value[1] != "") {
              if (filter.name) {
                filters[filter.name] = {
                  [item.filter.operator]: item.filter.value,
                };
              } else {
                filters[item.key] = {
                  [item.filter.operator]: item.filter.value,
                };
              }
            }
          } else {
            if (filter.value != "") {
              if (filter.name) {
                filters[filter.name] = {
                  [item.filter.operator]: item.filter.value,
                };
              } else {
                filters[item.key] = {
                  [item.filter.operator]: item.filter.value,
                };
              }
            }
          }
        }
      });

      params.filters = filters;

      if (this.selectedDevelopers.length > 0) {
        params.filters.developers = {
          $in: this.selectedDevelopers.map((item) => item.id),
        };
      }

      this.$axios
        .get(this.fetchAddress, {
          params,
        })
        .then((res) => {
          if (excel == false) {
            console.log("sajad");
            this.finalData = res.data.data;
            this.isFetched = true;
            this.totalRows = res.data.total;
          } else {
            this.$swal.fire(
              "موفق!",
              `عملیات گرفتن خروجی با موفقیت آغاز گردید و نتیجه از طریق پیامک به شما ابلاغ خواهد شد`,
              "success"
            );
          }
        });
    },
    fetchDevelopers() {
      this.$axios.get("developers").then((res) => {
        this.developers = res.data;
        this.fetchData();
      });
    },
    itemDeleted(item) {
      const data = JSON.parse(JSON.stringify(this.finalData));
      data.splice(this.finalData.indexOf(item), 1);
      this.finalData = data;
      this.totalRows = this.totalRows - 1;
    },
    getCellSlotName(key) {
      return "cell(" + key + ")";
    },
    operatorChange(index, $event) {
      this.fields[index].filter.operator = $event;
      this.fetchData();
    },
  },
};
</script>
<style>
.b-table-top-row td {
  text-align: center;
}
</style>
